import { computed, ref } from 'vue'

import axios from 'axios'

const noncompliance_model_categories = ref([])
const noncompliance_model_category_filters = ref({})
const filtered_noncompliance_model_categories = ref([])

export default function useNoncomplianceModelCategories() {
  const listNoncomplianceModelCategories = async () => {
    axios
      .get('/api/noncompliance_model_categories/all')
      .then(function (response) {
        noncompliance_model_categories.value =
          filtered_noncompliance_model_categories.value = response.data.data
      })
      .catch(function () {})
  }

  return {
    noncompliance_model_categories: computed(
      () => noncompliance_model_categories.value,
    ),
    noncompliance_model_category_filters: noncompliance_model_category_filters,
    filtered_noncompliance_model_categories: computed(
      () => filtered_noncompliance_model_categories.value,
    ),
    listNoncomplianceModelCategories,
  }
}
